import { render, staticRenderFns } from "./OptaTeamSetup.vue?vue&type=template&id=326307e8&"
import script from "./OptaTeamSetup.vue?vue&type=script&lang=js&"
export * from "./OptaTeamSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports